import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL } from "../utility/URL";


const save = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "bank-master/bank-insert-update", data, headerConfig);
        return response.data;
  };


const list = async () => {
    const response = await axios
        .post(BASE_API_URL + "programme/bank-list", {}, headerConfig);
        return response;
};

const edit = async (data) => {
    try {
        const response = await axios.get(`${BASE_API_URL}bank-master/get-bank-by-id/${data.bank_id}`, headerConfig);
        return response.data;
    } catch (error) {
        console.error("Error fetching bank details:", error);
        throw error; // Ensure to propagate the error for debugging
    }
};




// const deleteclub = async (data) => {
//     const response = await axios
//         .post(BASE_API_URL + "club/delete", data, headerConfig);
//         return response.data;
//   };




const bankMasterService = {
    save,
    list,
    edit           
};

export default bankMasterService;